
import { ICurrencyOptions } from './interfaces';

export const currencyOptions: ICurrencyOptions = {
	USDT: { value: 'USDT', img: 'https://coinivore.com/wp-content/uploads/2020/11/Tether-USDT.png' },
	BTC: {
		value: 'BTC',
		img: 'https://freepngimg.com/download/bitcoin/59686-offering-initial-bitcoin-cryptocurrency-ethereum-coin-silver.png',
	},
	ETH: {
		value: 'ETH',
		img: 'https://www.pngkit.com/png/full/264-2645350_ethereum-coin-png-ethereum.png',
	},
};

